import MobileMenuAbilities from './MobileMenuAbilities';

export default MobileMenuAbilities;
